import { makeStyles } from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  root: {
    border: '1px dashed #C0C0CF',
    borderRadius: '4px',
    '& .MuiTableCell-root': {
      color: '#32324D',
      borderBottom: '1px solid #F6F6F9'
    },
    '& .MuiTableCell-head': {
      fontWeight: 600,
      fontSize: '11px',
      textTransform: 'uppercase',
      color: '#666687',
    }
  },
  customInput: {
    '& > div.MuiInputBase-root': {
      '& .MuiOutlinedInput-input.MuiInputBase-input': {
        padding: '6px'
      }
    }
  },
  dialog: {
    '& > .MuiDialog-container .MuiDialog-paper': {
      minWidth: '650px'
    },
    '& .MuiAutocomplete-inputRoot[class*=\'MuiOutlinedInput-root\']': {
      padding: '6px'
    }
  }
}));
